import { SchedulerItem, SchedulerItemContent, SchedulerItemProps } from "@progress/kendo-react-scheduler"
import React from "react"

function CustomDayItem(props:SchedulerItemProps){
    return <React.Fragment>
        <SchedulerItem {...props} style={props.style}>
            {props.children}
            <SchedulerItemContent>
                <div>
                    <div style={{fontSize:'10px'}}>{props.dataItem.physician }</div>
                    <div style={{fontSize:'10px'}}>{props.dataItem.procedure}</div>
                </div>
            </SchedulerItemContent>
        </SchedulerItem>
    </React.Fragment>
}
export {CustomDayItem}